import { createWrapper } from '../../fhir-react/base';

export const ActivityDefinitionWrapper = createWrapper(
  'ActivityDefinition',
  (activityDefinition) => ({})
);

export type WrappedActivityDefinition = ReturnType<typeof ActivityDefinitionWrapper>;
